import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
    cellHeaderText: {
        width: 'max-content',
        whiteSpace: 'nowrap',
    },
});
